__turbopack_context__.v({
  "memberEmail": "MemberAccessRow-module__AXD-jW__memberEmail",
  "pendingText": "MemberAccessRow-module__AXD-jW__pendingText",
  "row": "MemberAccessRow-module__AXD-jW__row",
});
